import { _debounce, _throttle } from './debounce';
// eslint-disable-next-line @typescript-eslint/naming-convention
export function _Debounce(wait, opt = {}) {
  return (_target, _key, descriptor) => {
    const originalFn = descriptor.value;
    descriptor.value = _debounce(originalFn, wait, opt);
    return descriptor;
  };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export function _Throttle(wait, opt = {}) {
  return (_target, _key, descriptor) => {
    const originalFn = descriptor.value;
    descriptor.value = _throttle(originalFn, wait, opt);
    return descriptor;
  };
}